var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-chart',{attrs:{"options":_vm.chartOptions,"colors":['grey', 'green'],"data":{
        labels: [_vm.data.map(function (x) { return x.t; })],
        datasets: [
            {
                label: 'Projection',
                data: _vm.generateProjection,
                maxBarThickness: 12,
                borderDash: [10, 5],
                fill: false,
            },
            {
                label: 'Real',
                data: _vm.data,
                tension: 0,
                maxBarThickness: 12,
            } ],
    },"type":"line","height":"300"}})}
var staticRenderFns = []

export { render, staticRenderFns }